(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');

  /* ---------------------------------------------
     DESKTOP
  --------------------------------------------- */

  const activateDesktopPanel = (details, index) => {
    const tabs = Array.from(details.querySelectorAll('[data-mega-tab]'));
    const panels = Array.from(details.querySelectorAll('[data-mega-panel]'));

    tabs.forEach((tab) => {
      const active = Number(tab.dataset.megaTab) === index;

      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
    });

    panels.forEach((panel) => {
      panel.hidden = Number(panel.dataset.megaPanel) !== index;
    });
  };

  const initDesktopMegaMenus = (scope = document) => {
    scope.querySelectorAll('.mega-menu--editorial').forEach((details) => {
      if (details.dataset.one8DesktopReady === 'true') return;

      details.dataset.one8DesktopReady = 'true';

      const summary = details.querySelector(':scope > summary');
      const tabs = Array.from(details.querySelectorAll('[data-mega-tab]'));

      let closeTimer;

      const openMenu = () => {
        if (!desktopQuery.matches) return;

        window.clearTimeout(closeTimer);

        document.querySelectorAll('.mega-menu[open]').forEach((other) => {
          if (other === details) return;

          other.removeAttribute('open');

          other
            .querySelector(':scope > summary')
            ?.setAttribute('aria-expanded', 'false');
        });

        details.setAttribute('open', '');
        summary?.setAttribute('aria-expanded', 'true');
      };

      const closeMenu = () => {
        if (!desktopQuery.matches) return;

        window.clearTimeout(closeTimer);

        closeTimer = window.setTimeout(() => {
          details.removeAttribute('open');
          summary?.setAttribute('aria-expanded', 'false');
        }, 160);
      };

      details.addEventListener('mouseenter', openMenu);
      details.addEventListener('mouseleave', closeMenu);

      summary?.addEventListener('focus', openMenu);

      details.addEventListener('focusout', (event) => {
        if (!details.contains(event.relatedTarget)) {
          closeMenu();
        }
      });

      tabs.forEach((tab, index) => {
        tab.addEventListener('mouseenter', () => {
          activateDesktopPanel(details, index);
        });

        tab.addEventListener('click', (event) => {
          event.preventDefault();
          activateDesktopPanel(details, index);
        });

        tab.addEventListener('focus', () => {
          activateDesktopPanel(details, index);
        });
      });

      if (tabs.length) {
        activateDesktopPanel(details, 0);
      }
    });
  };


  /* ---------------------------------------------
     MOBILE
     Horizontal screen navigation:
     Root -> Mega group -> Category submenu.
  --------------------------------------------- */

  const initMobileDrawer = (scope = document) => {
    scope.querySelectorAll('[data-one8-mobile-drawer]').forEach((details) => {
      if (details.dataset.one8MobileReady === 'true') return;

      details.dataset.one8MobileReady = 'true';

      const screens = Array.from(
        details.querySelectorAll('[data-mobile-screen]')
      );

      const history = [];

      const getScreen = (name) => {
        return screens.find(
          (screen) => screen.dataset.mobileScreen === name
        );
      };

      const resetScreens = () => {
        history.length = 0;

        screens.forEach((screen) => {
          screen.classList.remove('is-active', 'is-behind');
        });

        getScreen('root')?.classList.add('is-active');
      };

      const goForward = (name) => {
        const current = screens.find((screen) =>
          screen.classList.contains('is-active')
        );

        const next = getScreen(name);

        if (!next || next === current) return;

        if (current) {
          history.push(current.dataset.mobileScreen);
          current.classList.remove('is-active');
          current.classList.add('is-behind');
        }

        next.classList.remove('is-behind');
        next.classList.add('is-active');
        next.scrollTop = 0;
      };

      const goBack = () => {
        const current = screens.find((screen) =>
          screen.classList.contains('is-active')
        );

        const previousName = history.pop();
        const previous = getScreen(previousName || 'root');

        if (!previous) return;

        current?.classList.remove('is-active');

        previous.classList.remove('is-behind');
        previous.classList.add('is-active');
      };

      details.addEventListener('click', (event) => {
        const forwardButton = event.target.closest('[data-mobile-target]');

        if (forwardButton && details.contains(forwardButton)) {
          event.preventDefault();
          goForward(forwardButton.dataset.mobileTarget);
          return;
        }

        const backButton = event.target.closest('[data-mobile-back]');

        if (backButton && details.contains(backButton)) {
          event.preventDefault();
          goBack();
        }
      });

      details.addEventListener('toggle', () => {
        document.body.classList.toggle(
          'one8-mobile-menu-open',
          details.open
        );

        if (details.open) {
          resetScreens();
        }
      });

      details.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          details.removeAttribute('open');
        }
      });

      resetScreens();
    });
  };


  /* ---------------------------------------------
     INIT
  --------------------------------------------- */

  const init = (scope = document) => {
    initDesktopMegaMenus(scope);
    initMobileDrawer(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => init(document),
      { once: true }
    );
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
